import { DirectUpload } from "@rails/activestorage"

/**
 * Wrapper around DirectUpload to make it work with async/await
 * @param file
 * @param url
 * @returns {Promise<ActiveStorage.Blob>}
 */
export function asyncDirectUpload(file: File, url: string): Promise<ActiveStorage.Blob> {
  return new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, url)

    upload.create((error, blob) => {
      if (error) {
        reject(error)
      } else {
        resolve(blob)
      }
    })
  })
}
